import React from "react";
import { Link } from "react-router-dom";
import { Infinity as InfinityIcon, Box, RotateCcw, Wand2 } from "lucide-react";

export default function Designer() {
  return (
    <main className="pt-16 md:pt-[72px] min-h-[80vh] flex items-center">
      <div className="max-w-[900px] mx-auto px-4 md:px-8 py-20 text-center">
        <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.24em] text-neon">
          <span className="w-2 h-2 rounded-full bg-neon animate-pulse" /> Coming soon
        </span>
        <h1 className="font-display text-5xl md:text-8xl text-white mt-5 leading-[0.9] flex flex-col items-center gap-2">
          Design in 3D
          <InfinityIcon className="text-neon neon-glow" size={64} />
        </h1>
        <p className="mt-6 text-white/65 max-w-xl mx-auto text-lg">
          Drop your own infinity graffiti on a 3D garment, spin it, and grab it. The full 3D
          designer is dropping in a future release. Until then — the lineup's live and waiting.
        </p>

        <div className="mt-12 grid sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
          {[
            { icon: Wand2, t: "Drop your graffiti", d: "Paint the infinity mark your way." },
            { icon: RotateCcw, t: "Spin it", d: "Preview your fit in full 3D." },
            { icon: Box, t: "Grab it", d: "Order it print-on-demand." },
          ].map((f) => (
            <div key={f.t} className="rounded-lg border border-white/10 bg-card p-6 text-left">
              <f.icon className="text-neon" size={26} />
              <h3 className="mt-4 font-semibold text-white">{f.t}</h3>
              <p className="mt-1 text-sm text-white/55">{f.d}</p>
            </div>
          ))}
        </div>

        <Link
          to="/shop"
          className="inline-block mt-12 bg-neon text-black font-bold uppercase tracking-[0.16em] text-sm px-10 py-4 rounded-full hover:brightness-95 transition"
        >
          Shop the Drop
        </Link>
      </div>
    </main>
  );
}
